function parsePath(d: string): any[] {
  const result: any[] = [];
  const tokens = d.trim().split(/[\s,]+/);
  let i = 0;
  while (i < tokens.length) {
    const token = tokens[i];
    if (token === "M" || token === "m") {
      result.push("M");
      i++;
    } else if (token === "L" || token === "l") {
      result.push("L");
      i++;
    } else if (token === "Z" || token === "z") {
      result.push("Z");
      i++;
    } else if (token === "Q" || token === "q") {
      result.push("Q");
      i++;
    } else {
      result.push(parseFloat(token));
      i++;
    }
  }
  return result;
}

interface EntityDefinition {
  outlines: string[];
  label: string;
  shortLabel: string;
  labelPosition: [number, number];
  labelAlignment?: "center" | "left" | "right" | "middle" | "top" | "bottom";
  labelConnectors?: string[];
}

export interface CustomMapOptions {
  name: string;
  displayName: string;
  entities: Record<string, EntityDefinition>;
}

export function CustomFusionMap(options: CustomMapOptions) {
  const parsedEntities = Object.fromEntries(
    Object.entries(options.entities).map(([id, entity]) => [
      id,
      {
        ...entity,
        labelAlignment: entity.labelAlignment ?? ["center", "middle"],
        outlines: (Array.isArray(entity.outlines)
          ? entity.outlines
          : [entity.outlines]
        ).map((path) => [parsePath(path)]),
        ...(entity.labelConnectors && {
          labelConnectors: [
            (Array.isArray(entity.labelConnectors)
              ? entity.labelConnectors
              : [entity.labelConnectors]
            )
              .map((path) => parsePath(path))
              .flat(),
          ],
        }),
      },
    ]),
  );

  return function (FC: any) {
    const geodefinitions = [
      {
        name: options.displayName,
        revision: 1,
        standaloneInit: true,
        creditLabel: false,
        baseWidth: 800,
        baseHeight: 441,
        baseScaleFactor: 1,
        entities: parsedEntities,
      },
    ];

    FC.addDep({ extension: geodefinitions, name: options.name, type: "maps" });
  };
}
